import React from 'react';
import {
  ServiceCategory,
  ServiceCategoryId,
} from '../constants';
import styles from '../Services.module.css';

interface ServicesCategoryBarProps {
  categories: ServiceCategory[];
  selectedCategory: ServiceCategoryId;
  onSelectCategory: (categoryId: ServiceCategoryId) => void;
}

const getIconUrl = (fileName: string) => `${process.env.PUBLIC_URL}/icons/${fileName}`;

const ServicesCategoryBar: React.FC<ServicesCategoryBarProps> = ({
  categories,
  selectedCategory,
  onSelectCategory,
}) => (
  <div className={styles.categoryBar}>
    <div className={`container ${styles.categoryBarInner}`}>
      <div className={styles.categoryList}>
        {categories.map((category) => (
          <button
            key={category.id}
            type="button"
            onClick={() => onSelectCategory(category.id)}
            className={`${styles.categoryButton} ${selectedCategory === category.id ? styles.categoryButtonActive : ''}`.trim()}
          >
            {category.iconFile ? (
              <span
                className={styles.categoryButtonIcon}
                style={{'--services-category-icon-url': `url("${getIconUrl(category.iconFile)}")`} as React.CSSProperties}
                aria-hidden="true"
              />
            ) : (
              <span className={styles.categoryButtonEmoji} aria-hidden="true">{category.icon}</span>
            )}
            <span>{category.name}</span>
          </button>
        ))}
      </div>
    </div>
  </div>
);

export default React.memo(ServicesCategoryBar);
